import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { useAuth } from '../../AuthContext.js';
import SalesmanForm from '../components/SalesmanForm.js';
import { CSVLink } from 'react-csv';
import { Button, Box } from '@mui/material';
import axios from 'axios';
import SalesmanReport from '../components/SalesmanReport.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SalesmanPage = () => {

    const { userRole } = useAuth()
    const [employee, setEmployee] = useState(true);
    const [showPopup, setshowPopup] = useState(false);
    let [selectedRow, setSelectedRow] = useState(null);
    const [ReportPopup, setReportPopup] = useState(false);
    const [ReportData, setReportData] = useState();

    useEffect(() => {
        if (userRole === "manager") {
            setEmployee(false)
        } else {
            setEmployee(true)
        };
    }, [userRole])

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchSalesmen = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/salesman/all_salesmen`);
                const responseData = await response.json();
                if (responseData) {
                    setData(responseData.salesmen);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchSalesmen();
    }, []);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Salesman ID',
                size: 100,
            },
            {
                accessorKey: 'fullname',
                header: 'Salesman Name',
                size: 100,
            },
            {
                header: 'Report',
                size: 200,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <Button
                            variant="contained"
                            onClick={() => toggleReportPopup(cell.row.original)}
                            sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '10px', py: '4px', color: 'white', fontSize: '14px' }}
                        >
                            Generate Report
                        </Button>
                    </Box>
                ),
            },
        ],
        [],
    );

    const togglePopup = () => {
        setshowPopup(!showPopup)
    }

    const toggleReportPopup = (reportdata) => {
        setReportPopup(!ReportPopup)
        setReportData(reportdata)
    }

    const DeleteSalesman = async (selectedRowId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/salesman/delete_salesman`, {
                data: {
                    id: selectedRowId
                }
            });
            if (response.status === 200) {
                toast.success(`Salesman with Id ${selectedRowId} deleted successfully!"`);
            } else {
                toast.success(`Salesman with Id ${selectedRowId} failed to delete!"`);
            }
        } catch (error) {
            toast.error(`Error deleting salesman.`);
        }
    };

    return (
        <>
            <StickyTitle title="Salesmen" button_action={togglePopup} button="New Salesman" />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
                <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
                    <div className='text-2xl ml-2 font-bold font-poppins'>All Salesman</div>
                </div>

                {data ? (<div className="w-full">
                    <MaterialReactTable
                        // enableRowActions
                        enableRowSelection
                        columns={columns}
                        data={data}
                        renderTopToolbarCustomActions={({ table }) => {
                            const handleDelete = () => {
                                const selectedRows = table.getSelectedRowModel().flatRows;

                                if (selectedRows.length === 1) {
                                    selectedRow = selectedRows[0];
                                    const selectedRowId = selectedRow.original.id;
                                    setSelectedRow(selectedRow);
                                    alert('Deleting Salesman with ID: ' + selectedRowId);
                                    DeleteSalesman(selectedRowId)
                                } else {
                                    alert('Please select a single row to delete.');
                                }
                            };

                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="error"
                                        disabled={!table.getIsSomeRowsSelected()}
                                        onClick={handleDelete}
                                        variant="contained"
                                        sx={employee ? { display: 'none' } : {}}
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={data}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            )
                        }}
                    />
                </div>) : (null)}
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
                    <div className="z-50 bg-white p-6 rounded-md shadow-lg flex flex-col gap-3">
                        <div className="flex justify-end">
                            <button
                                className="text-gray-500 hover:text-gray-700"
                                onClick={togglePopup}
                            >
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                        <SalesmanForm />
                    </div>
                </div>

            )}

            {ReportPopup && (
                <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
                    <div className="bg-white rounded-lg p-4 shadow-md ">
                        <button
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                            onClick={toggleReportPopup}
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                        <div style={{
                            height: '90vh',
                            overflowY: 'auto',
                        }}>
                            <SalesmanReport id={ReportData.id} />
                        </div>
                    </div>
                </div >
            )}

        </>
    );
};

export default SalesmanPage;
